module.exports = __webpack_public_path__ + "img/onLaptop.9e8795ef.svg";